import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit } from 'react-icons/fa'; // FontAwesome icons for preview and edit

const MailBody = ({ emailData, onBodyChange, onBlur }) => {
  const [htmlCode, setHtmlCode] = useState('');
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    if (emailData?.body) {
      setHtmlCode(emailData.body); // Set the email body when emailData changes
    }
  }, [emailData]);

  const togglePreview = () => {
    setShowPreview((prev) => !prev);
  };

  const handleHtmlCodeChange = (e) => {
    const updatedHtmlCode = e.target.value;
    setHtmlCode(updatedHtmlCode);
    if (onBodyChange) {
      onBodyChange(updatedHtmlCode); // Notify parent of body change
    }
  };

  return (
    <>
      <div className="p-2 mt-3 max-w-4xl mx-auto">
        <div className="relative rounded-lg shadow-md bg-white">
          {/* Buttons placed over the editor/preview */}
          <div className="absolute top-2 left-2 flex gap-4">
            <button
              onClick={togglePreview}
              className="z-50 px-3 py-1 text-white text-sm rounded-lg shadow-md bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 flex items-center gap-2"
            >
              {showPreview ? <FaEdit /> : <FaEye />}
              {showPreview ? 'Edit HTML' : 'Show Preview'}
            </button>
          </div>

          {/* Editor / Preview Section */}
          <div className="relative h-[550px] border rounded-md overflow-hidden shadow-sm">
            {!showPreview ? (
              <textarea
                value={htmlCode}
                onBlur={onBlur} // Call onBlur when the textarea loses focus
                onChange={handleHtmlCodeChange}
                disabled
                placeholder="<p>Write your HTML code here...</p>"
                className="w-full h-full font-mono bg-gray-900 text-white text-sm p-4 pt-12 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            ) : (
              <>
                <div className="p-6 pt-12 text-xs font-500">
                  <div>[customer name]</div>
                  <div>[Address]</div>
                  <div>Customer No.[contact-No]</div>
                  <div className="mt-1">Dear Sir/Madam,</div>
                  <div>
                    Our records indicate that payment for your account is now
                    overdue.
                  </div>
                  <div className="mt-1">Overdue amount Details :</div>
                  <div>[(90days before)3rd month :..$]</div>
                  <div>[(60days before)2nd month :..$]</div>
                  <div>[(30days before)1st month :..$]</div>
                  <div>[Current month :..$]</div>
                  <div>[Total:..$]</div>
                </div>
                <div
                  className="w-full h-full px-6 prose max-w-none overflow-auto text-sm"
                  dangerouslySetInnerHTML={{ __html: htmlCode }}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MailBody;
